import { render } from "./OuterFileInputPage.vue?vue&type=template&id=507f805e&scoped=true&ts=true"
import script from "./OuterFileInputPage.vue?vue&type=script&lang=ts"
export * from "./OuterFileInputPage.vue?vue&type=script&lang=ts"

import "./OuterFileInputPage.vue?vue&type=style&index=0&id=507f805e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507f805e"]])

export default __exports__